import { createApi } from '@reduxjs/toolkit/query/react';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  IAppDataExportCancellationsPayload,
  IAppDataExportFeesPayload,
  IAppDataExportForwardsPayload,
  IAppDataExportPackagesPayload,
  IAppDataExportPortfolioPayload,
  IAppDataExportProductionDevicesPayload,
  IAppDataExportTransactionsPayload,
  IAppDataExportWalletTransactionsPayload,
} from '../types/data-export.types';

export const appDataExportApi = createApi({
  reducerPath: 'appDataExportApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin`),
  endpoints: (builder) => ({
    exportPortfolio: builder.query<Blob, IAppDataExportPortfolioPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/necs/go-certificates/grouped/export`,
        method: 'GET',
        params,
      }),
    }),
    exportForwards: builder.query<Blob, IAppDataExportForwardsPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/necs/forward-certificates/export`,
        method: 'GET',
        params,
      }),
    }),
    exportPackages: builder.query<Blob, IAppDataExportPackagesPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/necs/go-packages/export`,
        method: 'GET',
        params,
      }),
    }),
    exportTransactions: builder.query<Blob, IAppDataExportTransactionsPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/necs/transactions/export`,
        method: 'GET',
        params,
      }),
    }),
    exportProductionDevices: builder.query<Blob, IAppDataExportProductionDevicesPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/necs/production-devices/export`,
        method: 'GET',
        params,
      }),
    }),

    exportCancellations: builder.query<Blob, IAppDataExportCancellationsPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/eecs/cancellations/export`,
        method: 'GET',
        params,
      }),
    }),
    exportWalletTransactions: builder.query<Blob, IAppDataExportWalletTransactionsPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/crypto/transactions/export`,
        method: 'GET',
        params,
      }),
    }),
    exportFees: builder.query<Blob, IAppDataExportFeesPayload>({
      query: (params) => ({
        responseHandler: (response) => response.blob(),
        url: `/eecs/platform-fees/export`,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useLazyExportPortfolioQuery,
  useLazyExportForwardsQuery,
  useLazyExportPackagesQuery,
  useLazyExportTransactionsQuery,
  useLazyExportProductionDevicesQuery,
  useLazyExportCancellationsQuery,
  useLazyExportWalletTransactionsQuery,
  useLazyExportFeesQuery,
} = appDataExportApi;
